import BrandSideBar from 'features/home/components/organisms/BrandSideBar/BrandSideBar';

export default BrandSideBar;
